import './PopulationPercentage.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { debounce } from 'lodash';
import { FilterComponent } from './FilterComponent';
import { Flex, InputNumber, Slider, Space, Switch } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
const min = 0;
const max = 100;
export const PopulationPercentageFilter = (props) => {
    var _a, _b, _c;
    const { format, id, onChange, value, label } = props;
    const [displayRange, setDisplayRange] = useState([(_a = value === null || value === void 0 ? void 0 : value[0]) !== null && _a !== void 0 ? _a : min, (_b = value === null || value === void 0 ? void 0 : value[1]) !== null && _b !== void 0 ? _b : max]);
    const [excludeNulls, setExcludeNulls] = useState((_c = value === null || value === void 0 ? void 0 : value[2]) !== null && _c !== void 0 ? _c : false);
    const showClearButton = (value === null || value === void 0 ? void 0 : value[0]) || (value === null || value === void 0 ? void 0 : value[1]);
    const excludeNullsText = (value === null || value === void 0 ? void 0 : value[2]) ? ` ${COPY_SPECIFIC.EXCLUDING_EMPTY}` : '';
    const tagText = `${[value === null || value === void 0 ? void 0 : value[0], value === null || value === void 0 ? void 0 : value[1]].map((num) => `${num}%`).join(' - ')}${excludeNullsText}`;
    useEffect(() => {
        if (!value) {
            setDisplayRange([min, max]);
            setExcludeNulls(false);
        }
    }, [value]);
    const debouncedOnChange = useMemo(() => debounce((range, hideNulls) => {
        const [start, end] = range;
        const removeFilter = start === min && end === max && !hideNulls;
        setDisplayRange(range);
        onChange({
            [id]: {
                format,
                value: removeFilter ? null : [start, end, hideNulls]
            }
        });
    }, 300, { leading: false }), [format, id, onChange]);
    const handleChangeRange = useCallback((range) => {
        setDisplayRange(range);
        debouncedOnChange(range, excludeNulls);
    }, [debouncedOnChange, excludeNulls]);
    const handleChangeStart = useCallback((start) => {
        const [, end] = displayRange;
        setDisplayRange([start, end]);
        debouncedOnChange([start, Math.max(start, end)], excludeNulls);
    }, [debouncedOnChange, displayRange, excludeNulls]);
    const handleChangeEnd = useCallback((end) => {
        const [start] = displayRange;
        setDisplayRange([start, end]);
        debouncedOnChange([Math.min(start, end), end], excludeNulls);
    }, [debouncedOnChange, displayRange, excludeNulls]);
    const handleToggleNulls = useCallback((toggle) => {
        setExcludeNulls(toggle);
        debouncedOnChange(displayRange, toggle);
    }, [debouncedOnChange, displayRange]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { className: 'population-percentage-filter', tagProps: {
            label,
            value: showClearButton ? tagText : null
        } }),
        React.createElement(Space, { direction: 'vertical', size: 4 },
            React.createElement(Flex, { align: 'center', gap: 16 },
                React.createElement(InputNumber, { max: max, min: min, onChange: handleChangeStart, value: displayRange[0] }),
                React.createElement(Slider, { max: max, min: min, onChange: handleChangeRange, range: true, value: [displayRange[0], displayRange[1]] }),
                React.createElement(InputNumber, { max: max, min: min, onChange: handleChangeEnd, value: displayRange[1] })),
            React.createElement(Space, { size: 8 },
                React.createElement(Switch, { checked: excludeNulls !== null && excludeNulls !== void 0 ? excludeNulls : value === null || value === void 0 ? void 0 : value[2], onChange: handleToggleNulls }),
                COPY_SPECIFIC.EXCLUDE_EMPTY_VALUES))));
};
